import React, { useState } from 'react';
import './AdminTasks.scss';
import { setAdminDataTaskView} from '../../adminSlice';
import { addNewTask, updateNameTask, updateGroupTask, 
    setOpenDeleteTaskForm, setOpenDeleteGroupTaskForm, 
    setIdNameTaskForQuizes, getTaskDataMain, setOpenEditPaidTaskForm } from '../../../MainVIew/Tasks/taskSlice';
import DeleteTaskForm from './DeleteTaskForm';
import DeleteGroupTaskForm from './DeleteGroupTaskForm';
import EditPaidTaskForm from './EditPaidTaskForm';


const AdminTasks = (props) => {
    
    const [valueGroup, setValueGroup] = useState('выбрать');
    const [selectedNameGroupForUser, setSelectedNameGroupForUser] = useState('');
    const [selectedIdNameGroupForUser, setSelectedIdNameGroupForUser] = useState();
    const [newTaskName, setNewTaskName] = useState('');
    const [editGroup, setEditGroup] = useState(false);
    const [editNameTask, setEditNameTask] = useState(false);
    const [addNewTaskView, setAddNewTaskView] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState();
    const [selectedTaskNameForUser, setSelectedTaskNameForUser] = useState('');
    const [publicTask, setPublicTask] = useState(false);
    const [errorGroup, setErrorGroup] = useState('');

    const {dispatch} = props;




    //HADLE CHOOSE DATA TASK
    const onChooseDataTask = (e) => {
        const data = {
            taskId: e.target.value,
            taskName: e.target.dataset.value1,
        }
        props.handleAdminTasksView();
        dispatch(setAdminDataTaskView());
        dispatch(setIdNameTaskForQuizes(data));

        const taskId = Number(e.target.value);
        let tasksDataMain = props.tasksDataMain.tasksDataMain;
        console.log(taskId);

        setSelectedTaskId(taskId);

        
        if (tasksDataMain.length !== 0) {

                //CHECK IF EXIST IN DATA
            const findTaskId = (selectedId, data ) => {
                const result = data.findIndex(({taskId}) => taskId === selectedId);
                return result;
            }
            const result = findTaskId(taskId, tasksDataMain);
             console.log(result);
            
                if (result === -1) {
                    // console.log(e.currentTarget.value);
                    console.log('START GET TASK');
                    dispatch(getTaskDataMain(taskId));
                  
                    // console.log(selectedQuizId);
                    } 
        
            } else {
                dispatch(getTaskDataMain(taskId));
            }
        setEditGroup(false);
        setEditNameTask(false);
      
        setSelectedTaskId();
        setSelectedIdNameGroupForUser();
        setSelectedNameGroupForUser();
        setSelectedTaskNameForUser();

    }
        //HADLE CHOOSE GROUP
        
    const handleChooseGroup= (event) => {
       // console.log(event);
        const selectedName =event.target.options[event.target.selectedIndex].text;
        const selectedGroupId =Number(event.target.options[event.target.selectedIndex].value);


        //VALIDATE GROUP IF APPOINTED
        
        const resultValidation = props.tasksDataMain.userCreatorTasks.findIndex(item => 
                (item.group_id ===selectedGroupId));
        const resultValidation1 = props.tasksDataMain.userCreatorTasks.findIndex(item => 
                (item.group_id ===selectedGroupId) && (item.task_id === selectedTaskId));

       // console.log(selectedGroupId);
      // console.log(resultValidation);
      // console.log(resultValidation1);

        if ((resultValidation !== -1) && (resultValidation1 === -1)) {
            setErrorGroup('Такая группа уже назначена.Выберите другую группу.');
           // setEditGroup(false);
           setSelectedNameGroupForUser(selectedName);
           setSelectedIdNameGroupForUser(selectedGroupId); 
        } else if (((resultValidation !== -1) && (resultValidation1 !== -1)) || (resultValidation === -1)) {
            setErrorGroup('');
       // console.log(selectedName);
        setSelectedNameGroupForUser(selectedName);         

        //console.log(selectedGroupId);
       // console.log(event.target.selectedIndex);
        //console.log(event.target.options[0].value);
        setSelectedIdNameGroupForUser(selectedGroupId);
       }
    }
            //HADLE CHOOSE QUIZ
    const handleChooseQuiz = () => {
        
    }
    // HANDLE EXIT TASK
    const onClickEnd = () => {

    }
        //HANDLE ADD NEW TASK NAME
    const handleAddNewTaskName = (event) => {
        const newTaskName = event.target.value;
        setNewTaskName(newTaskName);
    } 
    //ADD NTASK
    const onClickAddTask = () => {
                console.log('Start add new task action');
                const data = {
                    
                    titleTask: newTaskName,
                }
                //console.log(data);
                dispatch(addNewTask(data));


    }
        //ADD NTASK
    const onClickEditNameTask = () => {
                console.log('Start edit name task action');
                const data = {
                    taskId: selectedTaskId,
                    titleTask: newTaskName,
                }
                
                //console.log(data);
              dispatch(updateNameTask(data));
              cleanFunction();


    }
    //SAVE TASK
    const onClickSaveTask = () => {
        const data = {
                    taskId: selectedTaskId,
                    groupId: selectedIdNameGroupForUser,
                    publicOption: publicTask
                };

        dispatch(updateGroupTask(data));
       /* setSelectedIdNameGroupForUser();
        setSelectedNameGroupForUser();*/
        cleanFunction();
       // setEditGroup(false);
        
    }

    // CLEAN FUNCTION
    const cleanFunction = () => {
        setSelectedTaskId();
        setSelectedTaskNameForUser();
        setSelectedIdNameGroupForUser();
        setSelectedNameGroupForUser();
        setEditGroup(false);
        setEditNameTask(false);
        setPublicTask(false);
        setNewTaskName('');
        document.getElementById("select-taskgroup").selectedIndex = 0;
        
    }
    //CLEAR INPUT FORMS
    const onClickClear = () => {
       // setEditGroup(false);
       // setEditNameTask(false);
       // setAddNewTaskView(true);
       /* setSelectedTaskId();
        setSelectedIdNameGroupForUser();
        setSelectedNameGroupForUser();
        setSelectedTaskNameForUser();
       
        document.getElementById("select-taskgroup").selectedIndex = 0;*/
        cleanFunction();
    }
    //  EDIT NOTE
    const onEditTask = (e) => {
        setNewTaskName(e.target.dataset.value1);
        setAddNewTaskView(false);
        setEditNameTask(true);
        setSelectedTaskId(Number(e.target.value));
        setSelectedTaskNameForUser(e.target.dataset.value1);
        setSelectedNameGroupForUser(e.target.dataset.value2);

        const isTrueSet = (e.target.dataset.value3 === 'true');
        setPublicTask(isTrueSet);
        
    }
     /*   //  EDIT GROUP
    const onEditGroup = (e) => {
        setEditGroup(true);
        setAddNewTaskView(false);
        setEditNameTask(true);
        setSelectedTaskId(Number(e.target.value));
        setSelectedTaskNameForUser(e.target.dataset.value1);
        setSelectedNameGroupForUser(e.target.dataset.value2);
        
    }*/
    //SET PUBLIC OPTION
    const handleSetPublicOption = () => {
        setPublicTask(!publicTask);
    }
    //  DELETE  NOTE
    const onDeleteTask = (e) => {
        setSelectedTaskId(e.target.value);
        dispatch(setOpenDeleteTaskForm());
    }
        //  DELETE  GROUP NOTE
    const onDeleteGroupTask = (e) => {
        setSelectedTaskId(e.target.value);
        dispatch(setOpenDeleteGroupTaskForm());
    }
    // ADD NEW TASK VIEW
    const onAddNewTaskView = () => {
        setEditGroup(false);
        setEditNameTask(false);
        setAddNewTaskView(true);
       /* setSelectedTaskId();
        setSelectedIdNameGroupForUser();
        setSelectedNameGroupForUser();
        setSelectedTaskNameForUser();*/
        cleanFunction();
    }
    // EDIT GROUP VIEW
    const editGroupView = () => {
         setEditGroup(!editGroup);
    }
    //RENDER OPTIONS FOR GROUP ADD USER
       const renderOptionsGroup = () => {
        let data = props.authData.contactsGroups;
       // console.log(data);
        return (
            data.map((item, index) => {
                return (
                    <option key={index} value={item.id} >{item.groupName}</option>
                    )
            }

            )
        );
    } 
        //RENDER USERS TASK
    const renderTasks = () => {
        let data = props.tasksDataMain.userCreatorTasks ;
        //console.log(data);
    // HANDLE PAID
    const onEditPaid = (e) => {
        console.log('1.1.12 edit paid');
    setSelectedTaskId(e.target.value);    
    dispatch(setOpenEditPaidTaskForm());    

    }
        

        return (

            data.map((item, index) => {
                        const priceElement = <div className="price-block">
            <p className="price">{item.price}</p><span className="rub"> ₽</span>
            </div> ;
                return (
                            <div className='container-row' key={index}>
                                <button className="task-button" value={item.task_id} data-value1={item.title} onClick={onChooseDataTask}>#{item.task_id} {item.title}</button>
                                {/*<button className={item.task_id !== selectedTaskId ?'smallbtnEdit':'smallbtnEdit-selected'} value={item.task_id}  onClick={onEditTask}></button>*/}
                                <button className='smallbtnDelete' value={item.task_id} onClick={onDeleteTask}></button>
                            
                                <input className="title-group-small" placeholder={item.group_name} disabled></input>
                                <input className="check-box1" type="checkbox" disabled checked={!item.public ? '' : 'checked'}></input>
                                <button className={item.task_id !== selectedTaskId ?'smallbtnEdit':'smallbtnEdit-selected'} value={item.task_id} data-value1={item.title} data-value2={item.group_name} 
                                data-value3={item.public}  onClick={onEditTask}></button>
                                <button className='smallbtnDelete'  value={item.task_id} onClick={onDeleteGroupTask} disabled ={item.group_id ? '' : 'disabled' }></button>
                                {item.paid ? priceElement: null}
                                <button className={item.task_id !== selectedTaskId ?'smallbtnEdit':'smallbtnEdit-selected'} value={item.task_id}   onClick={onEditPaid}></button>
                            </div>
                    )
            }

            )
        );
    } 
    const view = props.viewTasks;
    if (view) {
            return (
            
                <div className="AdminTasks">
                     <div className='container-row'>
                        <p className='title'>Задачи</p>
                    </div>
                    <div className='main-container'>

                        <div className='group-left'>
                            <div className="container-column">
                                <label htmlFor="new-taskname">Заголовок</label>
                                <input id="new-taskname" name="title-task" value ={newTaskName} placeholder=' название задачи ' onChange={handleAddNewTaskName}></input>
                                <button className='common-button' onClick={onClickAddTask} disabled ={addNewTaskView ? '' : 'disabled'}>Добавить</button>
                                <button className='common-button' onClick={onClickEditNameTask} disabled ={editNameTask ? '' : 'disabled'}>Сохранить</button>
                             </div>   
                                
                                
                                
                            

                            <div className="container-column">
                                <label >Доступ к Задаче</label>
                                <input name="title" placeholder={selectedTaskNameForUser} disabled></input>
                            </div>
                            <div className="container-column">
                                    <label htmlFor="checkbox2">Редактировать группу</label>
                                
                                    <input  className="check-box" type="checkbox" id="checkbox2" disabled ={editNameTask ? '' : 'disabled' } onChange={editGroupView} checked={!editGroup ? '' : 'checked'}></input>
                                    
                              

                            </div>
                             <div className="container-column">
                                    <label htmlFor="select-taskgroup">Выберите группу</label>
                                    <div className='container-row'>
                                        <select name="category" id="select-taskgroup" defaultValue={'Default'} value={selectedIdNameGroupForUser} onChange={handleChooseGroup} disabled ={editGroup ? '' : 'disabled'}>
                                            <option disabled  value="Default"></option>
                                            {renderOptionsGroup()}

                                        </select>
                                        <p className='remark'>(предварительно необходимо создать группы контактов(см. вкладку  Контакты))</p>
                                     </div>
                                     <p className='error-message'>{errorGroup}</p>
                            </div>
                            <div className="container-column">
                                <label >Группа контактов</label>
                                <input name="groups" placeholder={selectedNameGroupForUser} disabled></input>
                            </div>

                            <div className="container-column">
                                <label htmlFor="checkbox1">Видимость Задачи для всех пользователей</label>
                            <div className="container-row">
                                <input  className="check-box" type="checkbox" id="checkbox1" disabled ={editNameTask ? '' : 'disabled' } onChange={handleSetPublicOption} checked={!publicTask  ? '' : 'checked'}></input>
                                <p>(public)</p>
                            </div>    

                            </div>
                            <div className='container-row'>
                                <button className='common-button' onClick={onClickSaveTask} disabled ={(editGroup && (errorGroup.length ===0) || editNameTask)  ? '' : 'disabled'}>Сохранить</button>
                                <button className='common-button' onClick={onClickClear} disabled ={(editGroup && (errorGroup.length ===0) || editNameTask)  ? '' : 'disabled'}>Отмена</button>
                            </div>
                        </div>


                        <div className='group-right'>
                            <div className='container-row'>
                                <p className='p-title1'>Задачи WSC project</p>
                                <p className='p-title2'>Группы/Доступ(public/private)</p>
                            </div>
                            {renderTasks()}
                            <button className='common-button' onClick={onAddNewTaskView} >Добавить</button>
                        </div>
                    </div>
                        {props.tasksDataMain.openDeleteTaskForm ? <DeleteTaskForm
                        dispatch={dispatch}
                        
                        taskId={selectedTaskId}
                        /> : null}
                        {props.tasksDataMain.openDeleteGroupTaskForm ? <DeleteGroupTaskForm
                        dispatch={dispatch}
                        onClickClear = {onClickClear}
                        taskId={selectedTaskId}
                        /> : null}
                        {props.tasksDataMain.openEditPaidTaskForm ? <EditPaidTaskForm
                        dispatch={dispatch}
                        
                        taskId={selectedTaskId}
                        /> : null}
                        
                </div>
               

            )
        };
        

    
}
export default AdminTasks;